import React from 'react'
import { Helmet } from 'react-helmet-async'

import { PerformanceSummaryLayout } from '../../layouts/Performance'

const PerformanceSummaryPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Performance Center - ImageKit Dashboard</title>
      <meta
        name="description"
        content="performance center - historical summary"
      />
    </Helmet>
    <PerformanceSummaryLayout />
  </React.Fragment>
)

export default PerformanceSummaryPage
